module.exports = __webpack_public_path__ + "arrow-right_orange.cdcaf8177b3b9d9d1483.png";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/Template/images/arrow-right_orange.png
// module id = ../../../../../src/assets/Template/images/arrow-right_orange.png
// module chunks = 2